'use client';
import React, { ChangeEvent, forwardRef, useRef } from 'react';
import Button from '@pezeshk-book/ui-kit/button';
import Chip from '@pezeshk-book/ui-kit/chip';
import Div from '@pezeshk-book/ui-kit/div';
import Rating from '@pezeshk-book/ui-kit/rating';
import Text from '@pezeshk-book/ui-kit/text';
import TextField from '@pezeshk-book/ui-kit/text-field';
import CommentIcon from '@icons-components/comment-icon';
import { useDispatch } from 'react-redux';
import { AlertActions } from '@store/alert/alert-action';
import { SubmitFormProps } from './submit-form.props';
import useCaptcha from '@hooks/use-captcha';

const SubmitForm = forwardRef(({ submitHandler, directHandler, onChange, parentName, submitLoading, commentValue, hasScore = false, scoreCallBack, score = 0 }: SubmitFormProps, ref: any) => {
  const dispatch = useDispatch();
  const commentInputRef = useRef<any>(null);

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e);
  };

  const submitCommentHandler = (token: string) => {
    if (token) {
      submitHandler({ token });
      if (commentInputRef?.current) {
        commentInputRef.current.value = '';
      }
    } else {
      dispatch(AlertActions.showAlert({ severity: 'danger', text: 'در حال حاضر مشکلی پیش آمده است' }));
    }
  };

  const { handleReCaptchaVerify } = useCaptcha(submitCommentHandler);

  const clickDirectHandler = () => {
    directHandler({ id: '', name: '' });
  };

  const handleRatingChange = (e: number) => {
    if (scoreCallBack) {
      scoreCallBack(e);
    }
  };

  return (
    <Div ref={ref} className={'flex-col w-full gap-2 sm:gap-4'}>
      <Text align={'right'} typography={'lg'} className={'py-1 sm:py-3'} type={'bold'}>نظر خود را برایمان ارسال کنید</Text>
      {parentName !== '' ? (
        <Div className={'items-center gap-x-4 py-4'}>
          <Text
            typography={'sm'}
            color={'grey.700'}
            align={'right'}>
            شما در حال پاسخ به نظر {parentName} هستید
          </Text>
          <Chip
            onClick={clickDirectHandler}
            onDelete={clickDirectHandler}
            value={'حذف'}
            color={'red'}
            size={'small'}
          />
        </Div>
      ) : null}
      <TextField
        ref={commentInputRef}
        onChange={changeHandler}
        label="ثبت نظر"
        startAdornment={<CommentIcon/>}
        placeholder="متن ورودی"
        inputClassName={'!h-36'}
        multiline={true}
        hasCounter={true}
        maxLength={500}
        disabled={submitLoading}
        value={commentValue}
      />
      <Div className={'justify-end items-end gap-8 flex-col'}>
        {hasScore && !parentName ? (
          <Div className={'gap-4 items-center justify-center'}>
            <Text typography={'sm'} type={'bold'}>
              امتیاز شما :
            </Text>
            <Rating
              direction={'rtl'}
              onChange={handleRatingChange}
              value={score}
              size={'large'}
            />
          </Div>
        ) : null}
        <Button
          loading={submitLoading}
          disabled={submitLoading || commentValue === ''}
          onClick={handleReCaptchaVerify}
          fontType={'bold'}
          className={'w-44 sm:w-40 md:w-[156px]'}
        >
          ارسال نظر
        </Button>
      </Div>
    </Div>
  );
});

SubmitForm.displayName = 'SubmitForm';

export default SubmitForm;
